<template>
  <div>
    <header-bar>登録情報</header-bar>
    <div
      v-show="time_limited"
      class="page-block">
      <time-limitation @time-limited="time_limited = true" />
    </div>
    <div
      v-if="!time_limited"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アカウント情報 - 決済手段変更</h3>
      </div>
      <div
        v-if="subscriptionCarrierFeePending"
        class="subscription-carrier-fee-pending-block">
        <h2>【重要なお知らせ】</h2>
        <p
          class="subscription-carrier-fee-pending-notification">
          サブスクプランの料金改定に伴い、下記の期限までに決済情報の再登録が必要となります。<br>
          <br>
          <em>期限：2024年 2月29日 23時59分</em><br>
          <br>
          決済情報の再登録が完了するまで、支払い申請を含む一部のサービスをご利用いただくことができません。<br>
          お手数ですが、下記の「変更する」より<span>決済情報の再登録をお願いいたします。</span><br>
          <br>
          期限内に決済情報の再登録が完了しない場合、楽曲の配信停止および退会の手続きを取らせていただきます。<br>
          退会に伴いまして、<span>残高に計上されている収益をお支払することができなくなります。</span><br>
          ご理解の程、よろしくお願い申し上げます。<br>
        </p>
      </div>

      <div class="page-block__inner">
        <div class="profile_change_settlement-area">
          <div class="profile_change_settlement-area__text">
            変更後の決済情報をご入力ください。<br>
            現在のお支払い方法: {{ settlement_method.name }}
            <span v-if="current_card_num !== ''">
              （ご利用中カード下4桁：{{ current_card_num }}）
            </span>
          </div>
        </div>
        <alert-view
          title="決済手段変更処理が完了しませんでした"
          :errors="payment_errors" />
        <div class="form-wrap form--error">
          <div
            v-if="current_method === 2"
            class="form-group">
            <div class="form-label">
              <label
                class="control-label">
                決済方法<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <div class="form-item-inline">
                <div class="radio">
                  <label for="paymentCard">
                    <input
                      id="paymentCard"
                      v-model="payment_method"
                      type="radio"
                      name="settlement"
                      :value="1"
                      checked>
                    <div class="option-input"></div> クレジットカード
                  </label>
                </div>
                <div class="radio">
                  <label for="paymentMobile">
                    <input
                      id="paymentMobile"
                      v-model="payment_method"
                      type="radio"
                      name="settlement"
                      :value="2">
                    <div class="option-input"></div> キャリア決済
                  </label>
                </div>
              </div>
              <p class="form-caution-text">※キャリア決済の場合、事務手数料が発生いたします。</p>
            </div>
          </div>
          <credit-card
            v-if="payment_method === 1"
            :show-debit-card-text="true"
            @update="cardUpdate" />
          <div
            v-if="payment_method === 2"
            class="form-group">
            <div class="form-label">
              <label
                class="control-label">
                キャリア選択<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <div class="form-item-inline">
                <div class="c-select_wrap">
                  <select
                    v-model="carrier"
                    class="form-control c-select"
                    name="language">
                    <option
                      value="0"
                      disabled
                      selected
                      style="display:none;">
                      選択してください
                    </option>
                    <option
                      value="2">
                      NTTドコモ
                    </option>
                    <option
                      value="3">
                      au
                    </option>
                    <option
                      value="4">
                      ソフトバンク
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-btn-wrap">
          <a
            :class="['c-btn',{'c-btn--off':confirmButtonDisabled}]"
            @click.prevent="paymentClick">
            変更する<span class="c-btn__icon-arrow"></span>
          </a>
          <router-link
            class="c-btn c-btn--back c-btn--back-left"
            :to="{ name: 'profile' }">
            戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'
import CreditCard from '../SettlementMethod/CreditCard'
import AlertView from '../AlertView'
import TimeLimitation from './TimeLimitation'

export default {
  components: {
    HeaderBar,
    CreditCard,
    AlertView,
    TimeLimitation,
  },
  data() {
    return {
      current_method: 1,
      payment_method: 1,
      card_validated: false,
      card_info: {},
      carrier: 0,
      confirmButtonDisabled: true,
      settlement_method: {},
      payment_errors: [],
      time_limited: false,
      current_card_num: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['isSubscriber', 'subscriptionCarrierFeePending']),
    payment_method_id() {
      if (this.payment_method === 1) {
        return 1
      }
      return this.carrier
    },
    current_carrier() {
      if (this.settlement_method.method > 1) {
        return this.settlement_method.type + 1
      }
      return 0
    },
  },
  watch: {
    payment_method() {
      this.confirmButtonDisabled = !this.validate()
    },
    payment_method_id() {
      this.confirmButtonDisabled = !this.validate()
    },
    card_validated: {
      handler() {
        this.confirmButtonDisabled = !this.validate()
      },
    },
  },
  mounted() {
    this.settlement_method = this.$store.state.auth.subscription.settlement_method
    this.current_method = this.settlement_method.method
    if (this.current_method === 1) this.getCurrentCradNo()
  },
  methods: {
    cardUpdate(value) {
      this.card_validated = value.validated
      this.card_info = value.card_info
    },
    validate() {
      if (this.payment_method === 2) {
        return this.payment_method_id >= 2
      }
      return this.card_validated
    },
    async paymentClick() {
      this.payment_errors = []
      if (this.payment_method === 1) { // カード決済
        const apiKey  = await this.getApiKey()
        await window.axios.post('https://api3.veritrans.co.jp/4gtoken', {
          card_number: this.card_info.card_number,
          card_expire: this.card_info.card_expire,
          security_code: this.card_info.security_code,
          token_api_key: apiKey,
          lang: 'ja',
        }).then(async ({ data: mdkData }) => {
          await window.axios.put('/api/client/settlements/veritrans/card/subscription', {
            token: mdkData.token,
          }).then(({ data }) => {
            if (data.result) {
              if (Object.prototype.hasOwnProperty.call(data, 'responseContents')) {
                document.write(data.responseContents)
              } else {
                this.$router.push({ name: 'profile' })
              }
            } else {
              window.scrollTo(0, 0)
              this.payment_errors.push({ message: data.message })
            }
          })
        }).catch(({ response }) => {
          window.scrollTo(0, 0)
          if (response.data.message) {
            this.$store.commit('decrementLoadingCount')
            this.$store.dispatch('progress/reset')
            this.payment_errors.push({ message: response.data.message })
          } else {
            this.payment_errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
          }
        })
      } else { // キャリア決済
        await window.axios.put('/api/client/settlements/veritrans/carrier/subscription', {
          payment_method_id: this.payment_method_id,
        }).then(({ data }) => {
          if (data.result) {
            document.write(data.responseContents)
          } else {
            window.scrollTo(0, 0)
            this.payment_errors.push({ message: data.message })
          }
        }).catch(() => {
          window.scrollTo(0, 0)
          this.payment_errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
        })
      }
    },
    async getApiKey() {
      const { data }  = await window.axios.get('/api/client/settlements/veritrans/api_key')
      return data.token
    },
    async getCurrentCradNo() {
      const { data } = await window.axios.get('/api/client/settlements/veritrans/card')
      if (data) {
        this.current_card_num = data.card_no.slice(-4)
      }
    },
  },
}
</script>
<style scoped>
@media screen and (min-width: 896px) {
  .subscription-carrier-fee-pending-block{
      max-width: 1080px;
  }
}
@media screen and (max-width: 895px) {
  .subscription-carrier-fee-pending-block{
    width:95%;
  }
}
</style>
